module.exports = __webpack_public_path__ + "img/ssb_image9.d5f924dc.jpeg";